const UNSELECTED_MULTIOPTIONS = 'leads/filterTable/UNSELECTED_MULTIOPTIONS';
const SELECTED_MULTIOPTIONS = 'leads/filterTable/SELECTED_MULTIOPTIONS';
const REMOVE_ALL_FILTERS = 'leads/filterTable/REMOVE_ALL_FILTERS';

const CHECKBOX_SELECT = 'leads/filterTable/CHECKBOX_SELECT';
const SELECTED_OPTIONS = 'leads/filterTable/SELECTED_OPTIONS';

const SHOW_REPORT_MODAL = 'leads/filterTable/SHOW_REPORT_MODAL';
const ADD_TEXT_SEARCH = 'leads/filterTable/ADD_TEXT_SEARCH';
const ADD_FEEDBACK = 'leads/filterTable/ADD_FEEDBACK';

const REMOVE_TEXT_SEARCH = 'leads/filterTable/REMOVE_TEXT_SEARCH';
const SORT_TABLE = 'leads/filterTable/SORT_TABLE';

export {
  CHECKBOX_SELECT,
  SELECTED_OPTIONS,
  UNSELECTED_MULTIOPTIONS,
  REMOVE_ALL_FILTERS,
  SELECTED_MULTIOPTIONS,
  SHOW_REPORT_MODAL,
  ADD_TEXT_SEARCH,
  REMOVE_TEXT_SEARCH,
  SORT_TABLE,
  ADD_FEEDBACK
};
